import { GetStripeProducts, ApiClientError } from '@raydiant/api-client-js';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';

export interface UseGetStripeProductsOptions {
  enabled?: boolean;
}

export default function useGetStripeProducts(
  productIdentifier: string,
  opts: UseGetStripeProductsOptions = {},
) {
  const query = useProtectedQuery<GetStripeProducts, ApiClientError>(
    keys.stripeProducts(productIdentifier),
    () => raydiant.getStripeProducts({ productIdentifier }),
    {
      enabled: opts.enabled !== false && !!productIdentifier,
    },
  );

  return query;
}
